export enum GroupMappingType {
  RESTRICTED = "Restricted",
  OPEN = "Open"
}
